import * as React from 'react';
import * as styles from './ArrowIcon.css';
import { mergeStyles } from '@cian/utils';
import arrowIcon from './assets/arrow.svg';

interface IProps {
  direction: 'right' | 'left';
}

export const ArrowIcon = ({ direction }: IProps) => {
  return <img src={arrowIcon} {...mergeStyles(styles['arrow'], styles[`arrow-${direction}`])} />;
};
